import { PluraliseKey, pluralWords, singularWords } from "./constants";

// Function to format and pluralise text based on count and header type
export const formatWithPluralise = ({
  count,
  headerText,
}: {
  count: number;
  headerText: PluraliseKey; // Ensure headerText is of type PluraliseKey
}): string => {
  // Safely access singular and plural words using the headerText
  const singularWord = singularWords[headerText] || headerText;
  const pluralWord = pluralWords[headerText] || `${singularWord}s`;

  // Format the count and choose the correct word based on the count
  const formattedCount = count.toLocaleString();
  const pluralised = count === 1? singularWord : pluralWord;

  // Return the formatted string
  return `${formattedCount} ${pluralised}`;
};

export const getPluralisedHeader = (key: PluraliseKey): string => {
  return pluralWords[key];
};